import { getLocalStorage } from "../crud/crypt"

export const canAccess = (rol) => {
    const state = getLocalStorage()

    return rol.includes(state?.role)
}